import { Modal } from 'bootstrap';
import Noty from 'noty';

const OutletForm = () => {
	window.bootstrap = { ...window.bootstrap, Modal };

	const modal = document.querySelector('#outletFormModal');
	const form = modal?.querySelector('#outletForm');
	const modalSubtitleWrapper = modal?.querySelector('.outlet-subtitle-wrapper');
	const formInputProduct = form.querySelector('#outlet_form_product_input');

	const resetForm = (form, modal) => {
		modal.hide();
		form.reset();
		form.querySelectorAll('.form__label').forEach(e => {
			e.style.cssText = '';
			e.querySelector('.cf-label-name').style.cssText = '';
		});
	};

	const sendSuccess = (form, modal, successModal) => {
		resetForm(form, modal);
		successModal._element.querySelector('.success-title').textContent =
			'Заявка успешно отправлена!';
		successModal.show();
		setTimeout(() => {
			successModal.hide();
		}, 3500);
	};

	const sendContactForm = async formEvent => {
		formEvent.preventDefault();
		const form = formEvent.target;
		const successModal = new bootstrap.Modal('#successMessage');
		const dataForm = new FormData(form);
		const currentModal = bootstrap.Modal.getOrCreateInstance(modal);

		try {
			const response = await fetch('index.php?route=mail/mail_send/send', {
				method: 'POST',
				body: dataForm,
			});

			if (response.ok) {
				const data = await response.json();

				if (data.result === 'success') {
					sendSuccess(form, currentModal, successModal);
				} else {
					throw new Error('Ошибка в форме: ' + response.statusText);
				}
			} else {
				throw new Error('Ошибка на сервере: ' + response.statusText);
			}
		} catch (error) {
			resetForm(form, currentModal);
			new Noty({
				theme: 'relax',
				type: 'error',
				timeout: 3000,
				text: error.message,
			}).show();
			console.error(error);
		}
	};

	document.querySelectorAll('.outlet-product-card-btn-add').forEach(e => {
		e.addEventListener('click', item => {
			modalSubtitleWrapper.innerHTML = '';
			const productName = item.currentTarget.getAttribute('data-product-name');
			formInputProduct.value = productName;

			if (productName)
				modalSubtitleWrapper?.insertAdjacentHTML(
					'afterbegin',
					`<p>Ваш заказ: ${productName}</p>`,
				);
		});
	});

	document.querySelector('#outletSwitchAllProducts').addEventListener('change', e => {
		const isChecked = e.target.checked;
	
		const url = new URL(window.location.href);
		url.searchParams.set('ac', isChecked ? '1' : '0');
		
		window.location.href = url;
	});

	form?.addEventListener('submit', event => sendContactForm(event));
};

export default OutletForm;
